import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import useRouter from 'hooks/useRouter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PoaContractListView from '../../components/PoaContractListView';

PoaContractListScreen.propTypes = {};

function PoaContractListScreen(props) {
  // MARK: ---- PROPERTIES ----
  const { user } = useSelector((state) => state.auth);
  const router = useRouter();
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);

  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="px-4 my-4">
        <PoaContractListView showFullUI={true} prefKey={prefKey} />
      </div>
    </KT01BaseLayout>
  );
}

export default PoaContractListScreen;
